<fieldset
  [class]="checkboxGroupClass"
  [ngClass]="{ 'is-error': showError }"
  [disabled]="disabled"
  [attr.aria-required]="required"
  [attr.aria-invalid]="showError"
  attr.aria-describedby="{{ showError ? 'checkbox-g_' + id + '_error' : '' }}"
>
  <legend class="c-checkbox-list__legend" [innerHTML]="legend"></legend>
  <div class="c-checkbox-list__wrap">
    <div class="c-checkbox-list__list">
      <ng-content></ng-content>
    </div>
  </div>
</fieldset>
<ng-container *ngIf="showError">
  <asw-validation-error id="{{ 'checkbox-g_' + id + '_error' }}" [errorMessage]="errors[0]"></asw-validation-error>
</ng-container>
